import React, { useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { clinicImpersonated } from "../../../util/functions";
import { useUpdateGender } from "../hooks/use-update-gender";
import useGenderDropdownStyles from "./styles/styles";

const normalizeGender = (value) => {
  const v = String(value || "").trim().toLowerCase();
  if (v === "male") return "Male";
  if (v === "female") return "Female";
  return "";
};

export const GenderDropdown = ({ userId, initialGender = "", minWidth = 110, onChanged }) => {
  const classes = useGenderDropdownStyles();
  const { t, i18n } = useTranslation();
  const updateGenderMutation = useUpdateGender();

  const [gender, setGender] = useState(() => normalizeGender(initialGender));

  useEffect(() => {
    setGender(normalizeGender(initialGender));
  }, [initialGender]);

  const fontClass = i18n.language === "ar" ? classes.fontFamilyAlmarai : classes.fontFamilyEina;

  const disabled = clinicImpersonated() || updateGenderMutation.isPending;

  const handleChange = async (e) => {
    const nextGender = e.target.value;
    const previousGender = gender;
    setGender(nextGender);
    try {
      await updateGenderMutation.mutateAsync({ userId, gender: nextGender });
      onChanged?.(nextGender);
    } catch (err) {
      setGender(previousGender);
      console.log(err);
    }
  };

  return (
    <FormControl className={classes.genderFormControl}>
      <Select
        style={{ minWidth }}
        disabled={disabled}
        labelId="select-gender"
        id="select-gender"
        value={gender}
        onChange={handleChange}
        displayEmpty={true}
        classes={{ select: classes.genderSelect }}
        renderValue={(value) => (
          <span
            className={`${classes.genderSelectValue} ${fontClass} ${value ? "" : classes.genderPlaceholder}`}
          >
            {value ? t(value) : t("Select")}
          </span>
        )}
      >
        <MenuItem value={"Male"}>{t("Male")}</MenuItem>
        <MenuItem value={"Female"}>{t("Female")}</MenuItem>
      </Select>
    </FormControl>
  );
};
